import { Col, Flex, message, Row } from "antd";
import { useMutation } from "@tanstack/react-query";
import { ExternalWebhook } from "@rumble-it/common-lib/types/models/ExternalWebhook.interface";
import { useNavigate } from "react-router-dom";
import { createExternalWebhook } from "@/lib/api/resources/externalWebhooks";
import { ExternalWebhookFormCard } from "./components/ExternalWebhookForm";

export const ExternalWebhookCreate = () => {
  const navigate = useNavigate();

  const createExternalWebhookMutation = useMutation({
    mutationFn: (data: ExternalWebhook) => createExternalWebhook(data),
    onSuccess: () => {
      navigate("/external-webhooks");
      message.success("Externe webhook succesvol aangemaakt");
    },
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ExternalWebhookFormCard mutation={createExternalWebhookMutation} />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
